module.exports = __webpack_public_path__ + "static/media/squating_dancer.e7a78773.png";